import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { ResultModel } from "../models/result.model";
import { RoleModel } from '../models/role.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseService {

  listAllRole() {
    return this.httpClient.get<ResultModel<RoleModel[]>>(this.getApiUrl('roles'));
  }

}
